import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React from "react";
import H3Font from "Root/profile/components/common/H3Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./style.module.css";
import { useSelector } from "react-redux";
const AccountSubscriptionCard = ({ item_type, item_category, image_url, servings, price, actualPrice, }) => {
    const isMobile = useScreenWidth() < 768;
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const getCategory = () => {
        if (item_type === "target_hydration") {
            return "Free Gift";
        }
        if (item_category === "flavorboost") {
            return "Flavor Boost";
        }
        if (item_category.includes("_")) {
            return item_category.replace("_", " ");
        }
        if (isByb) {
            return item_category.toLowerCase().replace("personalized", "customized");
        }
        if (item_type === "greens") {
            return "";
        }
        return item_category;
    };
    return (_jsxs("div", { className: styles.account_subscription_card_body, children: [_jsx("div", { className: styles.account_subscription_card_upper_section, children: _jsx("img", { className: styles.account_subscription_card_img, src: image_url, alt: "product pic" }) }), _jsx("div", { className: styles.account_subscription_card_lower_section, children: _jsx(H3Font, { fontWeight: 400, children: item_type == "target_hydration"
                        ? "Hydration"
                        : item_type.includes("additional_")
                            ? item_category.split("_")
                            : item_type.includes("protein")
                                ? `${item_type} Powder`
                                : item_type.includes("wb22")
                                    ? "Water Bottle"
                                    : item_type === "greens"
                                        ? "Performance Greens"
                                        : item_type }) }), _jsxs("div", { className: styles.account_subscription_card_price_section, children: [servings && (_jsxs(_Fragment, { children: [_jsxs(LargeFont, { children: [servings, " servings"] }), isMobile ? null : _jsx(LargeFont, { children: "\u00A0|\u00A0" })] })), _jsxs("div", { className: styles.account_subscription_card_prices, children: [actualPrice !== price && (_jsxs(LargeFont, { fontWeight: 400, children: [_jsxs("span", { className: styles.account_subscription_card_price, children: ["$", price] }), "\u00A0"] })), _jsxs(LargeFont, { color: actualPrice !== price ? "#77b1ac" : "#333", fontWeight: 400, children: ["$", actualPrice] })] })] })] }));
};
export default AccountSubscriptionCard;
